import React, { useEffect } from "react";
import { Route, Switch } from "react-router-dom";
import { AdminLogin } from "./nii/AdminLogin";
import { ApplicationSubmissions } from "./nii/ApplicationSubmissions";

import { NTBCApplication } from "./ntbc/NTBCApplication";
import { NiiApplicationForm } from "./nii/NiiApplication";
import { NiiApplicationComplete } from "./nii/NiiApplicationComplete";

function App() {
  useEffect(() => {
    localStorage.clear();
  }, []);
  return (
    <Switch>
      <Route path="/" component={NTBCApplication} exact />
      <Route path="/apply" component={NiiApplicationForm} exact />
      <Route path="/submitted" component={NiiApplicationComplete} />
      <Route path="/admin/login" component={AdminLogin} />
      <Route path="/admin/submissions" component={ApplicationSubmissions} />
      <Route />
    </Switch>
  );
}

export default App;
